import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

export default function UserMenu() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);
  const btnRef = useRef(null);
  const navigate = useNavigate();

  const role = user?.role;
  const nombre = user?.nombre || user?.email || 'Usuario';
  const inicial = (nombre || 'U').trim().charAt(0).toUpperCase();

  useEffect(() => {
    function onClick(e) {
      if (open && panelRef.current && !panelRef.current.contains(e.target) && !btnRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  const ir = (ruta) => { setOpen(false); navigate(ruta); };

  // Accesos de configuración según rol
  const configItems = role === 'ADMINISTRADOR' ? [
    { label: 'Mi Empresa', icon: '🏢', ruta: '/configuracion' },
    { label: 'Usuarios / Cajeros', icon: '👥', ruta: '/configuracion/usuarios' },
    { label: 'Contabilidad', icon: '⚙️', ruta: '/contabilidad/configuracion' },
    { label: 'Email - SMTP', icon: '📧', ruta: '/configuracion/email' },
    { label: 'WhatsApp Business', icon: '📱', ruta: '/configuracion/whatsapp' },
    { label: 'Chat Widget', icon: '🔌', ruta: '/configuracion/chat-widget' },
    { label: 'Asistente IA', icon: '🤖', ruta: '/configuracion/asistente-ia' },
  ] : [];

  return (
    <div style={{ position: 'relative' }}>
      <button
        ref={btnRef}
        onClick={() => setOpen(o => !o)}
        aria-label="Menú de usuario"
        style={{
          display: 'flex', alignItems: 'center', gap: 8, background: 'none',
          border: 'none', cursor: 'pointer', color: '#fff', padding: '4px 6px', borderRadius: 8,
        }}
      >
        <span style={{
          width: 32, height: 32, borderRadius: '50%', background: '#FF7A00',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontWeight: 700, fontSize: 15, color: '#fff', flexShrink: 0,
        }}>{inicial}</span>
        <span style={{ fontSize: 10, color: '#cbd2e0', lineHeight: 1 }}>▼</span>
      </button>

      {open && (
        <div
          ref={panelRef}
          style={{
            position: 'absolute', top: 46, right: 0, width: 290, maxWidth: '92vw',
            background: '#fff', borderRadius: 12, boxShadow: '0 12px 40px rgba(0,0,0,.22)',
            zIndex: 1300, overflow: 'hidden', color: '#1f2937',
          }}
        >
          {/* Encabezado: bienvenida */}
          <div style={{ padding: '18px 18px 14px', display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{
              width: 46, height: 46, borderRadius: '50%', background: '#FF7A00',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 700, fontSize: 20, color: '#fff', flexShrink: 0,
            }}>{inicial}</span>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 12, color: '#6b7280' }}>Bienvenido de nuevo,</div>
              <div style={{ fontSize: 15, fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nombre}</div>
              {role && <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 1 }}>{role}</div>}
            </div>
          </div>

          {configItems.length > 0 && (
            <>
              <div style={{ borderTop: '1px solid #eef0f3' }} />
              <div style={{ padding: '8px 0', maxHeight: 300, overflowY: 'auto' }}>
                <div style={{ padding: '4px 18px 6px', fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  Configuración
                </div>
                {configItems.map(it => (
                  <button key={it.ruta} onClick={() => ir(it.ruta)} style={menuItemStyle}>
                    <span style={{ width: 22, textAlign: 'center' }}>{it.icon}</span>
                    <span>{it.label}</span>
                  </button>
                ))}
              </div>
            </>
          )}

          <div style={{ borderTop: '1px solid #eef0f3' }} />
          <button onClick={logout} style={{ ...menuItemStyle, color: '#dc2626', fontWeight: 600, padding: '14px 18px' }}>
            <span style={{ width: 22, textAlign: 'center' }}>⎋</span>
            <span>Cerrar sesión</span>
          </button>
        </div>
      )}
    </div>
  );
}

const menuItemStyle = {
  display: 'flex', alignItems: 'center', gap: 10, width: '100%',
  background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left',
  padding: '10px 18px', fontSize: 13.5, color: '#374151', fontFamily: 'inherit',
};
